import { TEXT_ALIGN } from "../../../../../utils/enums";
import GenericInput from "../../../../../common/GenericInput";
import GenericModal from "../../../../../common/GenericModal";
import GenericSelect from "../../../../../common/GenericSelect";
import { STATIC_STRINGS } from "../../../../../utils/Constants";

const questionTypesDropdown = STATIC_STRINGS.QUESTION_TYPES_DROPDOWN;

const AddTypeModal = ({
  setTopicsData,
  newQuestion,
  setNewQuestion,
  isModalOpen,
  setModalOpen,
}) => {
  const handleAddType = (topicIndex: number) => {
    setTopicsData((prevTopics) =>
      prevTopics.map((topic, i) =>
        i === topicIndex
          ? {
              ...topic,
              questionTypes: [...topic.questionTypes, { ...newQuestion }],
            }
          : topic
      )
    );
  };

  const handleConfirm = () => {
    handleAddType(newQuestion.index);
    setModalOpen("");
    setNewQuestion({
      index: 0,
      questionType: STATIC_STRINGS.MCQ,
      difficultyLevel: STATIC_STRINGS.EASY,
      numberOfQuestions: 1,
      additionalFeedback: "",
    });
  };

  const addTypeFields = [
    {
      label: STATIC_STRINGS.QUESTION_TYPE,
      component: GenericSelect,
      options: questionTypesDropdown.map((type) => ({
        label: type,
        value: type,
      })),
      value: newQuestion.questionType,
      onChange: (e: React.ChangeEvent<HTMLSelectElement>) =>
        setNewQuestion((p) => ({ ...p, questionType: e.target.value })),
      className: "w-1/2",
    },
    {
      label: STATIC_STRINGS.DIFFICULTY_LEVEL,
      component: GenericSelect,
      options: [
        { value: STATIC_STRINGS.EASY, label: STATIC_STRINGS.EASY },
        { value: STATIC_STRINGS.MEDIUM, label: STATIC_STRINGS.MEDIUM },
        { value: STATIC_STRINGS.HARD, label: STATIC_STRINGS.HARD },
      ],
      value: newQuestion.difficultyLevel,
      onChange: (e: React.ChangeEvent<HTMLSelectElement>) =>
        setNewQuestion((p) => ({ ...p, difficultyLevel: e.target.value })),
      className: "w-1/2",
    },
    {
      label: STATIC_STRINGS.NUMBER_OF_QUESTIONS,
      component: GenericInput,
      type: "number",
      textAlign: TEXT_ALIGN.center,
      value: newQuestion.numberOfQuestions.toString(),
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNewQuestion((p) => ({
          ...p,
          numberOfQuestions: Number(e.target.value),
        })),
      className: "w-1/2",
    },
    {
      label: STATIC_STRINGS.ADDITIONAL_REQUIREMENTS,
      component: GenericInput,
      type: "text",
      value: newQuestion.additionalFeedback,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNewQuestion((p) => ({
          ...p,
          additionalFeedback: e.target.value,
        })),
      className: "w-full",
    },
  ];

  return (
    <GenericModal
      title={STATIC_STRINGS.ADD_NEW_QUESTION}
      onClose={() => {
        setModalOpen("");
      }}
      onConfirm={handleConfirm}
      open={isModalOpen}
      body={
        <div>
          {addTypeFields.map(
            ({ label, component: Component, ...props }, index) => (
              <div key={index} className="flex flex-col pb-1 items-center">
                <label className="font-medium">{label} :&nbsp;</label>
                <Component {...props} />
              </div>
            )
          )}
        </div>
      }
    />
  );
};
export default AddTypeModal;
